import * as Yup from 'yup';

export const NONE_SIGNATURE_OPTION = {
	id: 'none',
	label: 'None',
	name: 'None',
	signature: '',
};

export const UNLAYER_EDITOR_MIN_HEIGHT = 800;

export const validationSchema = Yup.object()
	.shape({
		client: Yup.mixed().required('Client is required.'),
		to: Yup.array(),
		cc: Yup.array(),
		bcc: Yup.array(),
		subject: Yup.string().required('Subject is required.'),
		editorHtml: Yup.string().required('Email content is required.'),
	})
	.test('at-least-one-recipient', 'At least one recipient is required.', function (values) {
		const to = values?.to?.length > 0;
		const cc = values?.cc?.length > 0;
		const bcc = values?.bcc?.length > 0;

		if (to || cc || bcc) return true;

		return this.createError({
			path: 'to', // or 'recipients' if you prefer a global error field
			message: 'At least one recipient is required.',
		});
	});
